import type { SnakeCasedPropertiesDeep } from 'type-fest';
import { fetchForClient } from '~/infra/api/fetch-api';
import type { like } from '~/infra/api/rpc';

type LikeRequest = SnakeCasedPropertiesDeep<like.ILikeRequest>;

const SERVICE_PATH = '/like.LikeService';

export const likeStory = async (
  storyId: string,
  count?: number
): Promise<void> => {
  const req: LikeRequest = {
    story_id: storyId,
    count: count ?? 0,
  };
  await fetchForClient({
    path: `${SERVICE_PATH}/Like`,
    options: {
      body: JSON.stringify(req),
      method: 'POST',
    },
  });
};
